import React, { createContext, useContext } from "react";

interface LandingPageContentContextType {
  content: any;
}

const LandingPageContentContext = createContext<LandingPageContentContextType | undefined>(undefined);

export const LandingPageContentProvider: React.FC<{
  children: React.ReactNode;
  content: any;
}> = ({ children, content }) => {
  return (
    <LandingPageContentContext.Provider value={{ content }}>
      {children}
    </LandingPageContentContext.Provider>
  );
};

export const useLandingPageContent = () => {
  const context = useContext(LandingPageContentContext);
  return context?.content;
};